import { subscribe } from "@wordpress/data";
import domReady from "@wordpress/dom-ready";
import React from "react";
import { LibraryModalTrigger } from "../components/library-modal-v2/LibraryModal";
import { localized } from "../utils";
import { renderer } from "./utils";

const addToolbarLibraryButton = () => {
	domReady(() => {
		if (
			"widgets" === pagenow ||
			"customize" === pagenow ||
			!localized.configs.editor["design-library"]
		)
			return;

		let timeout: null | number = null;
		const unsubscribe = subscribe(() => {
			const toolbar = document.querySelector(".edit-post-header-toolbar");

			if (!toolbar) return;

			const wrapper = document.createElement("div");
			wrapper.classList.add("mzb-library-button-wrapper");

			if (!toolbar.querySelector(".mzb-library-button-wrapper")) {
				renderer(() => <LibraryModalTrigger />, wrapper);
				toolbar.appendChild(wrapper);
			}

			if (timeout) clearTimeout(timeout);

			timeout = setTimeout(() => {
				if (document.querySelector(".mzb-import-button-wrapper")) {
					unsubscribe();
				}
			}, 0);
		});
	});
};

export default addToolbarLibraryButton;
